import { render, staticRenderFns } from "./modalRechazarCambios.vue?vue&type=template&id=963d7b76&scoped=true&"
import script from "./modalRechazarCambios.vue?vue&type=script&lang=js&"
export * from "./modalRechazarCambios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963d7b76",
  null
  
)

export default component.exports